import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetFormato = ()  => {
    const api = useApi();

    const mutate = async (param) => {
        const { data } = await api.get(`/formatos-etiquetas/${param}`);
        return data;
    };

    const mutation = useMutation(mutate);

    return {
        getFormato: mutation.mutate,
    };
}
